/**
 * AP-style month abbreviations ("Sept", not "Sep") — matches the campaign
 * copy voice ("Ends Sept 6"). `toLocaleDateString` can't produce these.
 */
const MONTHS = [
  'Jan',
  'Feb',
  'March',
  'April',
  'May',
  'June',
  'July',
  'Aug',
  'Sept',
  'Oct',
  'Nov',
  'Dec',
] as const;

/**
 * Formats a bonus window's `ends_at` (ISO8601) as "Sept 6" for
 * "Ends Sept 6" / "Double payouts end Sept 6" copy. Uses the device's
 * local date: the server sends the exact window end (11:59pm ET), which
 * lands on the advertised day for the app's US audience.
 */
export function formatPromoEndDate(iso: string): string {
  const date = new Date(iso);
  return `${MONTHS[date.getMonth()]} ${date.getDate()}`;
}
